module.exports = __webpack_public_path__ + "static/media/angle-down.57e82b8e.svg";